import React from 'react'

const MaterialArrowUp = () => (
  <svg className="icon">
    <use
      xlinkHref={`/Static/Images/icons.svg?=${
        process.env.BUILD_VERSION_ID
      }#icon--keyboard_arrow_up`}
    />
  </svg>
)

export default MaterialArrowUp
